import { Modal } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Axios from 'axios';
import UserContext from '../contexts/userContext';
import './MapContainer.scss';
import StudentMainPage from '../layout/StudentMainPage';

import GumletPlayer from '../components/GumletPlayer';
import IslandFeed, { IslandSlide } from '../components/IslandFeed';
import studentMissionState from '../enums/studentMissionState';
import { getIslandVideoId } from '../enums/missionNameToVideoId';

const INTRO_VIDEO_ID = '6a7dc47488bbabcd786d6a89';
const ISLANDS_BG_AUDIO_SRC = '/tracks/ISLANDs_background.mp3';

const getLastOpenedSlideIndex = (missions) => {
  let lastOpenedMissionIndex = -1;
  missions?.forEach((mission, index) => {
    if (mission.state && mission.state !== studentMissionState.locked) {
      lastOpenedMissionIndex = index;
    }
  });
  return lastOpenedMissionIndex === -1 ? 0 : lastOpenedMissionIndex + 1;
};

const MapContainer = () => {
  // const [missions, setMissions] = useState([]);
  const [studentMissions, setStudentMissions] = useState([]);
  const [missionsLoaded, setMissionsLoaded] = useState(false);
  const user = useContext(UserContext);
  const history = useHistory();

  useEffect(() => {
    const getStudentMissions = async () => {
      try {
        const studentMissionsRes = await Axios.get(`/api/users/${user.userId}/missions`);

        if (!studentMissionsRes.data) {
          Modal.error({
            title: `
            אין כלל משימות המשוייכות למשתמש, יש לפנות למדריך
          `,
          });
          return;
        }

        if (!Array.isArray(studentMissionsRes.data)) {
          throw new Error('שגיאה 1 בטעינת המשימות');
        }

        if (!studentMissionsRes?.data.length) {
          Modal.error({
            title: `
            אין משימות משוייכות למשתמש, יש לפנות למדריך
          `,
          });
          return;
        }
        setStudentMissions(
          studentMissionsRes.data?.sort(
            (a, b) => (a.mission?.displayOrder ?? 0) - (b.mission?.displayOrder ?? 0),
          ),
        );
      } catch (error) {
        Modal.error({ title: `אירעה שגיאה בעת טעינת המשימות: ${error}. \n\n נא לדווח למדריך` });
        throw error;
      } finally {
        setMissionsLoaded(true);
      }
    };
    if (user) getStudentMissions();
  }, [user, user?.userId]);

  const gotoMission = async (studentMission) => {
    history.push(`/missions/${studentMission.missionId}`);
  };

  const renderMissionIcon = (studentMission) => {
    if (!studentMission.state || studentMission.state === studentMissionState.locked) {
      return <div className="locked-mission-icon" />;
    }
    if (studentMission.state === studentMissionState.open) {
      return <div className="enter-mission-icon" />;
    }

    return <div className="visited-mission-icon" />;
  };

  return (
    <StudentMainPage>
      <div className="map-container">
        {!missionsLoaded ? (
          <div className="map-container-loading" />
        ) : (
          <IslandFeed
            initialIndex={getLastOpenedSlideIndex(studentMissions)}
            bgAudioSrc={ISLANDS_BG_AUDIO_SRC}
          >
            <IslandSlide key="intro">
              <GumletPlayer
                videoId={INTRO_VIDEO_ID}
                background={false}
              />
            </IslandSlide>
            {studentMissions?.map((studentMission) => {
              const islandVideoId = getIslandVideoId(studentMission.missionId);
              return (
                <IslandSlide
                  key={studentMission.missionId}
                  icon={renderMissionIcon(studentMission)}
                  title={studentMission.mission.txt}
                  onClick={() => {
                    if (!studentMission.state
                       || studentMission.state === studentMissionState.locked) return;
                    gotoMission(studentMission);
                  }}
                  forceMutedAudio
                >
                  {islandVideoId && (
                    <GumletPlayer
                      videoId={islandVideoId}
                      title={studentMission.mission.txt}
                    />
                  )}
                </IslandSlide>
              );
            })}
          </IslandFeed>
        )}
      </div>
    </StudentMainPage>
  );
};

export default MapContainer;
